import { useTranslate } from 'ra-core'

const AdFormatTitle = ({ record }: { record?: { code?: string } }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Ad Format')} - {record && record.code ? `"${record.code}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./AdFormatList') },
  edit: { lazy: () => import('./AdFormatEdit') },
  create: { lazy: () => import('./AdFormatCreate') },
  options: {
    create: {
      title: 'Create Ad Format',
      subtitle: null,
      breadCrumb: 'Create Ad Format',
    },
    list: {
      title: 'Ad Formats',
      subtitle: null,
      breadCrumb: 'Ad Formats',
    },
    edit: {
      title: <AdFormatTitle />,
      subtitle: null,
      breadCrumb: 'Edit Ad Format',
    },
  },
}
